type IconSortCustomProps = {
  order?: string;
};
export const IconSortCustom = ({ order }: IconSortCustomProps) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 1.68628C7.16407 1.68628 7.31771 1.76678 7.4111 1.90167L10.0361 5.69334C10.142 5.84625 10.1542 6.04527 10.0679 6.21C9.98158 6.37473 9.81097 6.47795 9.625 6.47795H4.375C4.18903 6.47795 4.01842 6.37473 3.93211 6.21C3.8458 6.04527 3.85805 5.84625 3.96391 5.69334L6.58891 1.90167C6.6823 1.76678 6.83593 1.68628 7 1.68628Z"
        fill={order === 'desc' ? '#818181' : '#D2D2D2'}
      />
      <path
        d="M3.93211 8.66248C4.01842 8.49775 4.18903 8.39453 4.375 8.39453H9.625C9.81097 8.39453 9.98158 8.49775 10.0679 8.66248C10.1542 8.82721 10.142 9.02623 10.0361 9.17914L7.4111 12.9708C7.31771 13.1057 7 13.1862 7 13.1862C7 13.1862 6.6823 13.1057 6.58891 12.9708L3.96391 9.17914C3.85805 9.02623 3.8458 8.82721 3.93211 8.66248Z"
        fill={order === 'asc' ? '#818181' : '#D2D2D2'}
      />
    </svg>
  );
};
